import Vue from 'vue'
import Vuex from 'vuex'

import Tracking from './modules/tracking'
import Geofences from './modules/geofences'
import Routes from './modules/routes'
import Places from './modules/places'
import Reports from './modules/reports'
import Travels from './modules/travels'
import Account from './modules/account'
import Guests from './modules/guests'
import EventDialog from './modules/event-dialog'
import CommandsDialog from './modules/commands-dialog'
import ConfirmEmail from './modules/confirm-email'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Tracking,
    Geofences,
    Routes,
    Places,
    Reports,
    Travels,
    Account,
    Guests,
    EventDialog,
    CommandsDialog,
    ConfirmEmail
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js